import {
  ScanLine, LayoutDashboard, ShoppingCart, Package, Tags, Users as UsersIcon,
  Receipt, Store, ShoppingBag, Printer, FileBarChart, HandCoins, Boxes, Clock, DatabaseBackup, CreditCard, Server, Palette, ScrollText,
} from "lucide-react";

export const NAV = [
  {section: "Pengaturan", items: [{ to: "/appearance", label: "Tampilan / Tema", icon: Palette, roles: ["admin"] }]},
  {
    section: "Administrasi Master",
    items: [
      { to: "/master/platform", label: "Platform", icon: CreditCard, roles: ["admin"], masterOnly: true },
      { to: "/master/tenants", label: "Kelola Tenant", icon: Store, roles: ["admin"], masterOnly: true },
      { to: "/master/system", label: "Status VPS", icon: Server, roles: ["admin"], masterOnly: true },
      { to: "/master/backup", label: "Backup NAS & Jadwal", icon: DatabaseBackup, roles: ["admin"], masterOnly: true },
    ],
  },
  {
    section: null,
    items: [
      { to: "/pos", label: "Kasir", icon: ShoppingCart, roles: ["admin", "cashier"] },
      { to: "/transactions", label: "Transaksi", icon: Receipt, roles: ["admin", "cashier"] },
      { to: "/piutang", label: "Piutang", icon: HandCoins, roles: ["admin", "cashier"] },
    ],
  },
  {
    section: "Backoffice",
    items: [
      { to: "/dashboard", label: "Dashboard", icon: LayoutDashboard, roles: ["admin"] },
      { to: "/reports", label: "Laporan", icon: FileBarChart, roles: ["admin"] },
      { to: "/shifts", label: "Riwayat Shift", icon: Clock, roles: ["admin"] },
      { to: "/warehouse", label: "Penerimaan Gudang", icon: ScanLine, roles: ["admin", "warehouse"] },
      { to: "/whatsapp", label: "WhatsApp Toko", icon: ScanLine, roles: ["admin"], tenantOnly: true },
      { to: "/purchases", label: "Pembelian", icon: ShoppingBag, roles: ["admin"] },
      { to: "/products", label: "Produk & Stok", icon: Package, roles: ["admin"] },
      { to: "/stok", label: "Stok & Opname", icon: Boxes, roles: ["admin"] },
      { to: "/categories", label: "Kategori", icon: Tags, roles: ["admin"] },
      { to: "/users", label: "Pengguna", icon: UsersIcon, roles: ["admin"] },
      { to: "/stores", label: "Profil Toko", icon: Store, roles: ["admin"] },
      { to: "/backup", label: "Backup & Restore", icon: DatabaseBackup, roles: ["admin"] },
      { to: "/settings", label: "Printer", icon: Printer, roles: ["admin"] },
      { to: "/audit-logs", label: "Log Aktivitas", icon: ScrollText, roles: ["admin"] },
      { to: "/payment-methods", label: "Metode Pembayaran", icon: CreditCard, roles: ["admin"] },
    ],
  },
];

export const ROLE_LABELS = { admin: "Administrator", warehouse: "Gudang", cashier: "Kasir" };
export function navigationFor(role, tenantKind) {
 return NAV.map(group => ({ ...group, items: group.items.filter(item => item.roles.includes(role) && (!item.masterOnly || tenantKind === "master") && (!item.tenantOnly || tenantKind === "tenant")) })).filter(group => group.items.length);
}
